import './style.css'
// import * as dat from 'dat.gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'


/**
 * Base
 */


// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()

// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Textures
 */
const bakedTexture = textureLoader.load('baked.jpg')
bakedTexture.flipY = false
bakedTexture.encoding = THREE.sRGBEncoding
const matcapTexture = textureLoader.load('textures/matcaps/4.png')

/**
 * Fonts
 */
 const fontLoader = new THREE.FontLoader()

 fontLoader.load(
     'fonts/helvetiker_regular.typeface.json',
     (font) =>
     {
        const textGeometry = new THREE.TextBufferGeometry(
            'Coming Soon',
            {
                font: font,
                size: 0.3,
                height: 0.05,
                curveSegments: 7,
                bevelEnabled: true,
                bevelThickness: 0.01,
                bevelSize: 0.01,
                bevelOffset: 0,
                bevelSegments: 7
            }
        )
        textGeometry.center()

        const textMaterial = new THREE.MeshMatcapMaterial()
        textMaterial.matcap = matcapTexture
        const text = new THREE.Mesh(textGeometry, textMaterial)
        text.position.x = 3.2
        text.position.y = 3.6
        text.position.z = 3.2
        text.rotation.x = -0.5
        text.rotation.y = 0
        text.rotation.z = 0
        scene.add(text)

        /**
         * // Debug
            gui.add(text.position, 'x', - 10, 10, 0.1)
            gui.add(text.position, 'y', 0, 10, 0.1)
            gui.add(text.position, 'z', - 10, 10, 0.1)
            gui.add(text.rotation, 'x', - 10, 10, 0.1)
            gui.add(text.rotation, 'y', - 10, 10, 0.1)
            gui.add(text.rotation, 'z', - 10, 10, 0.1)
         */
     }
 )


/**
 * Materials
 */
// Baked material
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })

/**
 * Model
 */
gltfLoader.load(
    'room.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })
        scene.add(gltf.scene)
    }
)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(10, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 9.75
camera.position.y = 11.05
camera.position.z = 12.36
scene.add(camera)


/**
 * // Debug
gui.add(camera.position, 'x', - 50, 50, 0.01)
gui.add(camera.position, 'y', - 50, 50, 0.01)
gui.add(camera.position, 'z', - 50, 50, 0.01)
gui.add(camera, 'fov', - 50, 50, 0.01)
gui.closed = true;
 */

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true




/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setClearColor('#FFFFFF')

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()